export const wrapKey = (key: string): string => `{${key}}`;

export const textTemplate = (template = '', data: Record<string, unknown> = {}): string =>
  Object.entries(data).reduce((message, [key, value]) => message.replaceAll(wrapKey(key), `${value}`), template);
